import { React } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// import BootstrapModal from './BootstrapModal';


const useStyles2 = makeStyles({
    table: {
        // minWidth: 500,
    },
});
function SystemXUpdateLogTable(props) {
    const classes = useStyles2();
    const { rowsPerPage, rows, page } = props;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    const headings = ["SN", "Username", "Updator", "Update Date", "Actions"];
    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {headings.map((i) => <TableCell align="center"><b>{i}</b></TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(rowsPerPage > 0
                        ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : rows
                    ).map((row, i) => (
                        <TableRow key={i}>
                            <TableCell component="th" align="center" scope="row">{i + 1 + (page * rowsPerPage)}</TableCell>
                            <TableCell align="center">{row.username}</TableCell>
                            <TableCell align="center">{row.updator}</TableCell>
                            <TableCell align="center" >{row.updatedate}</TableCell>
                            <TableCell align="center">{row.actions}</TableCell>
                            {/* <TableCell align="center"><BootstrapModal row={row} database={database} fetchAllDataByOption={fetchAllDataByOption} /></TableCell> */}
                        </TableRow>
                    ))}
                    {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    )
}


export default SystemXUpdateLogTable
